var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"info","size":_vm.size},on:{"click":_vm.doExport}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }